// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article__back-btn[data-v-a47b56d4]{color:var(--color-primary-2)}.article__content[data-v-a47b56d4]{display:flex;flex-direction:column;gap:var(--spacing-xl-1);padding:var(--spacing-xl-1)}.article__author[data-v-a47b56d4]{color:var(--color-text-2);margin-top:var(--spacing-lg-1)}.article__date[data-v-a47b56d4]{color:var(--color-text-10);font-size:var(--font-size-sm-3);line-height:var(--line-height-tight)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
